<template>
  <BaseImage
    v-bind="$attrs"
    :src="asset ? require(`@assets/${asset}`) : src"
    :styleExtension="styleExtension"
  />
</template>

<script setup lang="ts">
import { useStyle } from '@composables/use-style';
import { useStyleExtension } from '@v1/composables/image';
import BaseImage from '@v1/components/base/BaseImage.vue';

const { spacing } = useStyle();

const props = defineProps({
  asset: {
    type: [Object, String],
    required: false,
    default: null,
  },
  interactive: {
    type: Boolean,
    required: false,
    default: false,
  },
  round: {
    type: Boolean,
    required: false,
    default: false,
  },
  src: {
    type: String,
    required: false,
    default: '//:0',
  },
});

const styleExtension = useStyleExtension({
  image: {
    borderRadius: props.round ? '50%' : spacing.SM,
    display: 'block',
    ...(props.interactive ? {
      filter: {
        '': 'none',
        hover: 'opacity(0.5)',
        active: 'opacity(0.5)',
        disabled: 'opacity(0.25)',
      },
      cursor: {
        '': 'pointer',
        disabled: 'default',
      },
    } : {}),
  },
});
</script>
